import React, { useState } from 'react';
import './MathApp.css';  // Import the CSS file for styling
import apple from './images/apple.jpg'; // Example image import, ensure you have images in your project

const numbers = Array.from({ length: 40 }, (_, i) => i + 1);

const getImageArray = (num) => Array.from({ length: num }, () => apple);

const MathApp = () => {
  const [num1, setNum1] = useState(1);
  const [num2, setNum2] = useState(1);
  const [operation, setOperation] = useState('add');
  const [result, setResult] = useState(0);

  const calculate = () => {
    if (operation === 'add') {
      setResult(num1 + num2);
    } else {
      setResult(num1 - num2);
    }
  };

  return (
    <div className="container">
      <h1>Math Fun for Kids</h1>
      <div className="select-container">
        <div className="select-item">
          <select value={num1} onChange={(e) => setNum1(parseInt(e.target.value, 10))}>
            {numbers.map((num) => (
              <option key={num} value={num}>
                {num}
              </option>
            ))}
          </select>
          <div className="image-display">
            {getImageArray(num1).map((img, index) => (
              <img key={index} src={img} alt="item" className="number-image" />
            ))}
          </div>
        </div>

        <select value={operation} onChange={(e) => setOperation(e.target.value)}>
          <option value="add">+</option>
          <option value="subtract">-</option>
        </select>

        <div className="select-item">
          <select value={num2} onChange={(e) => setNum2(parseInt(e.target.value, 10))}>
            {numbers.map((num) => (
              <option key={num} value={num}>
                {num}
              </option>
            ))}
          </select>
          <div className="image-display">
            {getImageArray(num2).map((img, index) => (
              <img key={index} src={img} alt="item" className="number-image" />
            ))}
          </div>
        </div>
      </div>

      <button onClick={calculate} className="calculate-button">Calculate</button>

      <div className="result-container">
        <p className="result">Result: {result}</p>
        <div className="image-display">
          {getImageArray(Math.abs(result)).map((img, index) => (
            <img key={index} src={img} alt="result-item" className="number-image" />
          ))}
        </div>
      </div>
    </div>
  );
};

export default MathApp;
